
    import {
      getAllAppointmentTypes,
      createAppointmentType,
      createAllAppointmentTypes,
      updateAppointmentType,
      deleteAppointmentType
    } from "@/services/appointmentType";

    const state = {
      appointmentTypes: [],
      processed: false
    };

    const getters = {
      getAppointmentTypes(state) {
        return state.appointmentTypes;
      },
      appointmentTypeProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchAppointmentTypes({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllAppointmentTypes(
              params
            )
              .then(response => {
                commit("SET_APPOINTMENTTYPES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAppointmentType({ commit }, appointmentType) {
          return new Promise((resolve, reject) => {
            createAppointmentType(appointmentType)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllAppointmentTypes({ commit }, appointmentTypes) {
          return new Promise((resolve, reject) => {
            createAllAppointmentTypes(appointmentTypes)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateAppointmentType({ commit }, appointmentType) {
          return new Promise((resolve, reject) => {
            updateAppointmentType(appointmentType)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteAppointmentType({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteAppointmentType(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_APPOINTMENTTYPES(state, data) {
        state.appointmentTypes = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    